class anchor {
  __constructor() {
    this.$anchors = document.querySelectorAll('[anchor]')
    this.$menu = document.querySelector('.main-menu')
  }

  _scrollTo($anchor) {
    let hash = $anchor.hash,
        $el = document.querySelector(hash ?? '')

    if($el !== null) {
      $el = $($el)
      let t = $el.offset().top,
          h = $(this.$menu).height()

      $('html, body').animate({
        scrollTop: t - h
      }, 250, () => {
        window.location.hash = hash;
      })
    }
  }

  init() {
    this.__constructor()
    // --
    if(this.$anchors.length)
      this.$anchors.forEach(($anchor) => {
        $anchor.addEventListener('click', (e) => {
          e.preventDefault()
          // --
          this._scrollTo($anchor)
        })
      })
  }
}
export default anchor
